import { useContext } from 'react'
import { DarkContext } from './DarkProvider'

export function useIsDark() {
    const { isDarkMode } = useContext(DarkContext)
    return isDarkMode
}
